export enum AppType {
    Initialized = 'initialized',
    FinishedLoading = 'finishedLoading',
    ToggledSidebar = 'toggledSidebar',
    ApiReturnedResponseCode = 'apiReturnedResponseCode',
    ValidatorFinishedLoading = 'validatorFinishedLoading',
}

export interface InitializedAction {
    type: AppType.Initialized;
}

export interface FinishedLoadingAction {
    type: AppType.FinishedLoading;
    url: string;
}

export interface ToggledSidebarAction {
    type: AppType.ToggledSidebar;
}

export interface ApiReturnedResponseCodeAction {
    type: AppType.ApiReturnedResponseCode;
    code: number;
    message: string;
}

export interface ValidatorFinishedLoadingAction {
    type: AppType.ValidatorFinishedLoading;
    caseId: string;
    label: string;
}

export const initialized = (): InitializedAction => ({
    type: AppType.Initialized,
});

export const finishedLoading = (url: string): FinishedLoadingAction => ({
    type: AppType.FinishedLoading,
    url,
});

export const toggledSidebar = (): ToggledSidebarAction => ({
    type: AppType.ToggledSidebar,
});

export const apiReturnedResponseCode = (code: number, message: string): ApiReturnedResponseCodeAction => ({
    type: AppType.ApiReturnedResponseCode,
    code,
    message,
});

export const validatorFinishedLoading = (
    caseId: string,
    label: string,
): ValidatorFinishedLoadingAction => ({
    type: AppType.ValidatorFinishedLoading,
    caseId,
    label,
});

export type AppActionTypes =
    | FinishedLoadingAction
    | InitializedAction
    | ToggledSidebarAction
    | ApiReturnedResponseCodeAction
    | ValidatorFinishedLoadingAction;
